import React from 'react';
import { useTranslation } from 'react-i18next';
import { Phone } from 'lucide-react';

const CTAButton = () => {
  const { i18n } = useTranslation();

  const handleClick = () => {
    // WhatsApp message in Arabic or English
    const message = i18n.language === 'ar' 
      ? 'السلام عليكم، أرغب في طلب خدمة قانونية من شركة وازن.'
      : 'Hello, I would like to request a legal service from Wazin Law Firm.';
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/966122226665?text=${encodedMessage}`;
    
    window.open(whatsappURL, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 left-6 z-50 bg-gradient-to-r from-wazin-gold to-wazin-gold-600 text-wazin-navy px-5 py-3 md:px-6 md:py-4 rounded-full font-bold shadow-2xl hover:shadow-3xl hover:scale-110 transition-all duration-300 flex items-center gap-2 md:gap-3"
      style={{ 
        direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
        marginBottom: 'max(1.5rem, env(safe-area-inset-bottom))' // Safe area for mobile
      }}
      aria-label={i18n.language === 'ar' ? 'اطلب الخدمة الآن' : 'Request Service Now'}
    >
      <Phone className="w-4 h-4 md:w-5 md:h-5" />
      <span className="text-sm md:text-base">
        {i18n.language === 'ar' ? 'اطلب الخدمة' : 'Request Service'}
      </span>
    </button>
  );
};

export default CTAButton;
